import {useState, useEffect} from 'react';
import moment from 'moment-timezone';
import NewsContent from "src/MarketDataComponents/News";

export default function News({newsHeadlines, quote}) {

    const renderNews = () => {

        if (newsHeadlines) {
            const {headlines} = newsHeadlines;
            
            if (headlines && headlines.length) {
                const formattedHeadlines = [];
                headlines.map((headline) => {
                    const date = moment(new Date(headline.dateTime));
                    formattedHeadlines.push({
                        href: `${process.env.NEXT_PUBLIC_BASE_PATH}/sub/${quote.marketCode}/news-item/${headline.id}`,
                        title: headline.title,
                        date: date.format("ddd, DD/MM/YYYY - HH:mm:ss"),
                        tags: [{ // Temp until we know what to do with tags
                            title: headline.tags[0],
                            href: "#"
                        }]
                    });
                });
                return <NewsContent news={[{
                    title: "REGULATORY NEWS",
                    newsItems: formattedHeadlines,
                    moreLink: `${process.env.NEXT_PUBLIC_BASE_PATH}/sub/${quote.marketCode}/news`
                }]} />
            }
        }

        return null;        
    }

    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm" id="newsContent">
            <h2 className="card-title" data-testid="overviewNewsHeader">News</h2>
            {renderNews()}
        </div>
    </div>
}